import { CheckboxWUT } from '@wix/form-fields/wut';

export default CheckboxWUT;
